import Sdk from "casdoor-js-sdk";

const config = {
  serverUrl: import.meta.env.VITE_CASDOOR_ENDPOINT,
  clientId: import.meta.env.VITE_CASDOOR_CLIENT_ID,
  organizationName: import.meta.env.VITE_CASDOOR_ORG_NAME,
  appName: import.meta.env.VITE_CASDOOR_APP_NAME,
  redirectPath: "/auth/callback",
};

export const casdoor = new Sdk(config);

export async function startFreshCasdoorSignin(accessToken?: string | null): Promise<void> {
  await clearCasdoorSso(accessToken);
  await casdoor.signin_redirect({ prompt: "login" });
}

async function clearCasdoorSso(accessToken?: string | null): Promise<void> {
  const serverUrl = config.serverUrl?.trim();
  if (!serverUrl) return;

  try {
    const init: RequestInit = {
      method: "POST",
      credentials: "include",
    };
    if (accessToken) {
      init.headers = { Authorization: `Bearer ${accessToken}` };
    }

    await fetch(`${serverUrl}/api/sso-logout?logoutAll=false`, init);
  } catch {
    // Best effort: still continue into the explicit login prompt below.
  }
}

export function getDeviceId(): string {
  let id = localStorage.getItem("gnpf-device-id");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("gnpf-device-id", id);
  }
  return id;
}

/**
 * Exchange the Casdoor authorization code for an access token.
 * The SDK reads the code + state from the current URL automatically
 * (PKCE flow). Returns the raw access_token string which is then
 * forwarded to BE /auth/device-session.
 */
export async function exchangeCodeForCasdoorToken(): Promise<string> {
  const tokenResp = await casdoor.exchangeForAccessToken();
  return tokenResp.access_token;
}
